import axios from "axios";

export const baseRequest = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api",
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

baseRequest.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      !error.config.url.includes("/login") &&
      !error.config.url.includes("/check-auth")
    ) {
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);
